export default __webpack_public_path__ + "static/media/34.bcfc5389.png";